export class ForgotPasswordModel
{
    public email: string;
    public client_id: string = "client-portal";
}